controllers.controller('WithdrawOtherController', [
    '$scope', '$state', '$stateParams', '$ionicLoading', '$ionicModal', 'LocaleService', 'API', 'ErrorService', 'constants',
    'Validator', 'Storage', 'Utils', 'UserService',
    function ($scope, $state, $stateParams, $ionicLoading, $ionicModal, LocaleService, API, ErrorService, Const,
              Validator, Storage, Utils, UserService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.validator = Validator.getPattern;
        $scope.user = UserService.get();
        $scope.constants = Const;
        $scope.modal = { actionText: LocaleService.translation.try_again, state: false };
        $scope.withdraw = { login: $stateParams.login, amount: $stateParams.amount };
        $scope.detailsModel = {};
        $scope.detailsModel.details = '';

        $scope.submit = function (form) {
            Utils.formRevalidate(form);
            if (!form.$valid) return;

            var request = {
                login: parseInt($scope.withdraw.login, 10),
                amount: parseInt($scope.withdraw.amount, 10),
                other: $scope.detailsModel.details
            };
            $ionicLoading.show();

            return API.withdrawalOther(request)
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();

                    if(Const.withdrawalComplianceRequired && $scope.user.complianceStatus !== 'approved') {
                        return $state.go('root.app.withdrawCompliance');
                    }

                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.textContent = '';
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                    $scope.modal.back = 'root.app.withdraw';
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawalFailed;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || '';
                    $scope.modal.state = true;
                });
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'WithdrawOtherController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }
    }]);
